import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { DIAGNOSTICS_CONNECTION_STEP } from '@store';

@Component({
  selector: 'app-diagnostics-connection-warning',
  templateUrl: './diagnostics-connection-warning.component.html',
  styleUrls: ['./diagnostics-connection-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosticsConnectionWarningComponent {
  @Output()
  cancel: EventEmitter<DIAGNOSTICS_CONNECTION_STEP> = new EventEmitter<
    DIAGNOSTICS_CONNECTION_STEP
  >();

  @Input() gatewaySerial: string;

  start(): void {
    this.cancel.emit(DIAGNOSTICS_CONNECTION_STEP.CONNECTION_ESTABLISHING);
  }
}
